import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { Component, Inject, OnInit } from '@angular/core';
import { EDI_INVOICE_MODAL_TYPE } from '@app/shared/constants';
import { AwbShipmentRO, ShipmentsService } from '@app/shared/services/shipments.service';
import { AdminScopes, AdminUser, UserService } from '@app/shared/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { LoggerService } from '@app/shared/services/logger.service';
import { BannerNotificationsService } from '@app/shared/services/banner-notifications.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmationComponent } from '@app/shared/components/modal-confirmation/modal-confirmation.component';

@Component({
  standalone: false,
  selector: 'app-update-awb',
  templateUrl: './update-awb.component.html',
})
export class UpdateAwbComponent implements OnInit {
  public awb: any;
  public adminUser: AdminUser;
  public note: string;
  public form: FormGroup;
  public isUpdating: boolean = false;

  constructor(
    private shipmentsService: ShipmentsService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private logger: LoggerService,
    private bannerNotificationsService: BannerNotificationsService,
    private dialog: MatDialog,
    public drawerRef: MtxDrawerRef<UpdateAwbComponent>,
    @Inject(MTX_DRAWER_DATA)
    public data: {
      awb: any;
      adminUser: AdminUser;
    }
  ) {}

  ngOnInit() {
    if (
      this.data &&
      this.data.awb &&
      this.data.adminUser &&
      this.userService.hasAuthScope(this.data.adminUser, [AdminScopes.MODIFY_AWB_LABELS])
    ) {
      this.awb = this.data.awb;
      this.adminUser = this.data.adminUser;
      this.createForm();
    } else {
      this.dismissDrawer();
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
        newAwbNumber: ['', Validators.maxLength(250)],
    });
  }

  public submitForm() {
    if (this.form.valid && !this.isUpdating) {
      this.isUpdating = true;
      this.update(this.awb);
    }
  }

  public update(awb: AwbShipmentRO): void {
    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      width: '600px',
      data: {
        title: 'Update AWB number',
        content: `Are you sure you want to update the AWB number from ${awb.awbNumber} to ${this.form.value.newAwbNumber}?`,
        btnColor: 'primary',
        confirmBtnLabel: 'Update AWB number',
      },
    });
    dialogRef.afterClosed().subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.shipmentsService.updateAWB(awb.awbNumber, { newAwbNumber: this.form.value.newAwbNumber }).subscribe(
          (res: any) => {
            this.logger.log('UPDATED AWB', res);
            this.bannerNotificationsService.success('AWB updated successfully');
            this.isUpdating = false;
            this.dismissDrawer(true);
          },
          (err: any) => {
            this.bannerNotificationsService.error('Could not update AWB', {
              category: 'UPDATED AWB error',
              message: err,
            });
            this.isUpdating = false;
          }
        );
      } else {
        this.bannerNotificationsService.success('AWB update cancelled');
        this.isUpdating = false;
      }
    });
  }

  public dismissDrawer(successful: boolean = false): void {
    this.drawerRef.dismiss(successful);
  }
}
